import React from 'react';

const GiftContext = React.createContext();

export default GiftContext;